import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {LocationDto} from '../model/continent';
import {environment} from '../environments/environment';
import {Pagination, PaginationParams} from '../model/pagination';
import {cleaningParams} from '../functions/cleaningParams';

@Injectable({
  providedIn: 'root'
})
export class ContinentService {
  constructor(private httpClient: HttpClient) {}

  getContinentList(params: PaginationParams): Observable<Pagination<LocationDto>>  {
    const cleanParams = cleaningParams(params);
    return this.httpClient.get<Pagination<LocationDto>>(`${environment.apiUrl}/public/continent`,
      { params: { ...cleanParams } });
  }

  getContinent(id: number): Observable<LocationDto>  {
    return this.httpClient.get<LocationDto>(`${environment.apiUrl}/public/continent/${id}`);
  }

  getContinentByUrl(url: string): Observable<LocationDto>  {
    return this.httpClient.get<LocationDto>(`${environment.apiUrl}/public/continent/by-url/${url}`);
  }

  moveUp(id: number): Observable<boolean>  {
    return this.httpClient.put<boolean>(`${environment.apiUrl}/continent/move-up/${id}`, id);

  }

  moveDown(id: number): Observable<boolean> {
    return this.httpClient.put<boolean>(`${environment.apiUrl}/continent/move-down/${id}`, id);
  }

  saveContinentPhoto(id: number, file: File) {
    const correctedFile = new File(
      [file],
      file.name.replace(/[\s()]/g, ''),
      { type: file.type }
    );
    const formData = new FormData();
    formData.append("file", correctedFile);
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/continent/file/${id}`, formData);
  }

  saveContinentFooterPhoto(id: number, file: File) {
    const correctedFile = new File(
      [file],
      file.name.replace(/[\s()]/g, ''),
      { type: file.type }
    );
    const formData = new FormData();
    formData.append("file", correctedFile);
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/continent/footer/file/${id}`, formData);
  }

  saveContinentCarousel(idContinent: number, idCarousel: number, file: File) {
    const correctedFile = new File(
      [file],
      file.name.replace(/[\s()]/g, ''),
      { type: file.type }
    );
    const formData = new FormData();
    formData.append("file", correctedFile);
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/continent/file/${idContinent}/${idCarousel}`, formData);
  }

  saveEventPhoto(idContinent: number, eventId: number, file: File) {
    const correctedFile = new File(
      [file],
      file.name.replace(/[\s()]/g, ''),
      { type: file.type }
    );
    const formData = new FormData();
    formData.append("file", correctedFile);
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/continent/file/event/${idContinent}/${eventId}`, formData);
  }

  saveAdditionalEventPhoto(idContinent: number, eventId: number, file: File) {
    const correctedFile = new File(
      [file],
      file.name.replace(/[\s()]/g, ''),
      { type: file.type }
    );
    const formData = new FormData();
    formData.append("file", correctedFile);
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/continent/file/additional-event/${idContinent}/${eventId}`, formData);
  }

  deleteContinentCarousel(idContinent: number, idCarousel: number) {
    return this.httpClient.delete(`${environment.apiUrl}/continent/${idContinent}/${idCarousel}`);
  }

  deleteEventCarousel(idContinent: number, eventId: number) {
    return this.httpClient.delete(`${environment.apiUrl}/continent/event/${idContinent}/${eventId}`);
  }

  saveContinent(continent: LocationDto): Observable<LocationDto> {
    return this.httpClient.post<LocationDto>(`${environment.apiUrl}/continent`, continent);
  }

  delete(id: number) {
    return this.httpClient.delete(`${environment.apiUrl}/continent/${id}`);
  }
}
